import {
  AMPLITUDE_EVENTS,
} from "./AmplitudeConstants.js";

// Tab index mappings for different contexts
export const dealerBundleTabEvents = {
  0: AMPLITUDE_EVENTS.DEALER_BUNDLE_DETAILS_OVERVIEW,
  1: AMPLITUDE_EVENTS.DEALER_BUNDLE_DETAILS_SPECIFICATIONS,
  2: AMPLITUDE_EVENTS.DEALER_BUNDLE_DETAILS_PRICING,
  default: AMPLITUDE_EVENTS.DEALER_BUNDLE_DETAILS_OVERVIEW,
};

export const dealerApiTabEvents = {
  0: AMPLITUDE_EVENTS.DEALER_API_DETAILS_OVERVIEW,
  1: AMPLITUDE_EVENTS.DEALER_API_DETAILS_SPECIFICATIONS,
  2: AMPLITUDE_EVENTS.DEALER_API_DETAILS_PRICING,
  3: AMPLITUDE_EVENTS.DEALER_API_DETAILS_DOCUMENTATION,
  4: AMPLITUDE_EVENTS.DEALER_API_DETAILS_CONTACT,
  default: AMPLITUDE_EVENTS.DEALER_API_DETAILS_OVERVIEW,
};

export const isvTabEvents = {
  0: { event: AMPLITUDE_EVENTS.API_OVERVIEW, tab: "Overview" },
  1: { event: AMPLITUDE_EVENTS.VIEW_SPECIFICATION, tab: "Specification" },
  2: { event: AMPLITUDE_EVENTS.VIEW_PRICING, tab: "Pricing" },
  3: { event: AMPLITUDE_EVENTS.VIEW_DOCUMENTATION, tab: "Documentation" },
  4: { event: AMPLITUDE_EVENTS.OPEN_CONTACT, tab: "Contacts" },
  default: { event: AMPLITUDE_EVENTS.API_OVERVIEW, tab: "Overview" },
};
